import { getFileExtension } from '@gorila-shared-ui/components';
import { FILE_EXTENSIONS, IMAGE_EXTENSIONS } from '../constants/app';

export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};

export function isValidImage(filename: string) {
  const fileExtension = getFileExtension(filename);
  return IMAGE_EXTENSIONS.includes(fileExtension);
}

export function isValidFile(filename: string) {
  const fileExtension = getFileExtension(filename);
  return FILE_EXTENSIONS.includes(fileExtension);
}

export function hasInvalidImages(files: File[]) {
  return files.some((file) => !isValidImage(file.name));
}

export function hasInvalidFiles(files: File[]) {
  return files.some((file) => !isValidImage(file.name) && !isValidFile(file.name));
}
